import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit, input, signal } from "@angular/core";
import { IonicModule, ModalController, Platform } from "@ionic/angular";
import { ModeService } from "src/app/utils/mode.service";
import { ServiceDto } from "../../interfaces/service_dto";
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { Store } from "@ngrx/store";
import { deleteService, upsertService } from "../../ngrx/settings.action";
import { JoyrideModule, JoyrideService } from "ngx-joyride";

@Component({
    selector: "app-service-dialog",
    templateUrl: "./service-dialog.component.html",
    styleUrls: ["./service-dialog.component.scss"],
    imports: [
        IonicModule,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        JoyrideModule,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServiceDialogComponent implements OnInit {
  readonly service = input<ServiceDto>(undefined);
  readonly tutorial = input<boolean>(false);
  readonly disableInput = signal(false);

  constructor(
    public modeService: ModeService,
    private platform: Platform,
    private modalController: ModalController,
    private store: Store<any>,
    private joyrideService: JoyrideService
  ) {}

  serviceForm: FormGroup;
  backButtonListener = null;

  ngOnInit() {
    this.initializeForm();
    this.serviceForm.patchValue(this.service());
    this.backButtonListener = this.platform.backButton.subscribeWithPriority(
      0,
      async (processNextHandler) => {
        if (this.joyrideService.isTourInProgress) {
          this.joyrideService.closeTour();
          this.disableInput.set(false);
        }
        processNextHandler();
      }
    );
  }

  ionViewDidEnter() {
    if (this.tutorial()) {
      this.joyrideService.startTour(
        { steps: ['service-category', 'service-price-duration', 'service-subscription'], customTexts: {
          next: "Weiter",
          prev: "Zurück",
          done: "Fertig",
        },
      }
      );
    }
  }

  ionViewDidLeave() {
    this.joyrideService.closeTour();
    this.backButtonListener.complete();
  }

  ngOnDestroy() {
    this.backButtonListener.complete();
  }

  private initializeForm() {
    this.serviceForm = new FormGroup({
      duration: new FormControl("", [Validators.required, Validators.min(1)]),
      prize: new FormControl("", [Validators.required, Validators.min(0)]),
      category: new FormControl("B", Validators.required),
      name: new FormControl("", Validators.required),
      subscription: new FormControl(true, Validators.required),
    });
  }
  save() {
    if (this.serviceForm.valid) {
      const service = this.service();
      if (service?.service_id) {
        const updatedService = {
          ...service,
          ...this.serviceForm.value,
        };
        this.store.dispatch(upsertService({ service: updatedService }));
      } else {
        this.store.dispatch(upsertService({ service: this.serviceForm.value }));
      }
    }
    this.modalController.dismiss();
  }
  delete() {
    this.store.dispatch(deleteService({ serviceId: this.service().service_id }));
    this.modalController.dismiss();
  }
  cancel() {
    this.modalController.dismiss();
  }
}
